Ext.define('SA.model.createimport.FileSchemaValidator', {
    constructor(file) {
        this.file = file;
        this.fileName = file.getFileName(); 
    },

    hasBlankHeaderName() {
        return this.file.getHeaderNames().some(name => name === '');
    },

    hasDuplicateHeaderName() {
        return SA.Array.hasDuplicates(this.file.getHeaderNames());
    },

    hasInconsistentColumnCount() {
        var columnCount = this.file.getColumnCount();

        return this.file.getRows().some(row => row.length !== columnCount);
    },

    hasNoDataRows() {
        return this.file.getRowCount() === 0;
    },

    hasSingleColumn() {
        return this.file.getColumnCount() === 1;
    },

    isValid() {
        if (!this.file.isReadable()) {
            return true;
        }

        return !this.hasBlankHeaderName() &&
            !this.hasDuplicateHeaderName() &&
            !this.hasNoDataRows() &&
            !this.hasSingleColumn() &&
            !this.hasInconsistentColumnCount();
    }
});